import React, {Component} from 'react';
import {connect} from 'react-redux';
import TeamChecking from './team-checking';
import TeamExposure from './team-exposure';

class StackTeams extends Component {
    render() {
        const {stacking, stackNumber} = this.props;
        const teams = stacking.getActiveTeamsByStackNumber(stackNumber);

        return (
            <>
                {Object.keys(teams).map((team) => {
                    return (
                        <div key={team} className="stack-box">
                            <TeamChecking team={team} stackNumber={stackNumber} />
                            <div className="min-max-group">
                                <div className="percent-in">
                                    <TeamExposure team={team} exposureType="min" stackNumber={stackNumber} />
                                    <span className="percent">%</span>
                                </div>
                                <div className="percent-in">
                                    <TeamExposure team={team} exposureType="max" stackNumber={stackNumber} />
                                    <span className="percent">%</span>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </>
        );
    }
}

function mapStatesToProps(state) {
    const {nonControlledHitterStacking} = state;
    return {
        stacking: nonControlledHitterStacking.settings,
    };
}

export default connect(mapStatesToProps)(StackTeams);
